import { InjectionToken } from '@angular/core';

import type { AuthUser } from './auth.service';

/**
 * Optional hook for resolving extra roles that aren't carried in the access
 * token. Keycloak's `realm_access.roles` only holds realm roles; org-scoped
 * roles (e.g. Phase Two `super-admin`) must be fetched from the BFF after
 * login. An app provides an implementation under `ES_ROLES_LOADER` and the
 * AuthService merges the result into `AuthUser.roles` during init, so every
 * role-based gate (guards, nav) keeps reading a single `roles` array.
 */
export interface EsRolesLoader {
  /** Resolve additional roles to merge for the just-authenticated user. */
  loadRoles(user: AuthUser): Promise<string[]>;
}

export const ES_ROLES_LOADER = new InjectionToken<EsRolesLoader>('ES_ROLES_LOADER');
